// import React from "react";
// import sliderImage from "../../assets/images/mainSlider.png";
//import sliderImage from "../../assets/images/mainSliderImage.png";
import { useLanguage } from "../../context/LanguageContext";
import SearchInput from "../SearchInput";
import Discount from "../discounts/Discount";
// import Discount from "../discounts/Discount";
// import main1 from "../../assets/images/main1.png";
// import main2 from "../../assets/images/main2.png";
// import main3 from "../../assets/images/main3.png";
// import main4 from "../../assets/images/main4.png";
// import main5 from "../../assets/images/main5.png";

// const data = [
//   {
//     img: main1,
//     name: "Medikal Ürünler",
//   },
//   {
//     img: main2,
//     name: "Spor Ürünleri",
//   },
//   {
//     img: main3,
//     name: "Ortopedik Yastık",
//   },
//   {
//     img: main4,
//     name: "Kompresyon Çorabı",
//   },
//   {
//     img: main5,
//     name: "Ortopedik Ayakkabılar",
//   },
// ];

const MainSlider = ({ scrolled }: any) => {
  const { t } = useLanguage();
  return (
    <div className=" flex flex-col mt-16 lg:-mt-10">
      <div className=" flex justify-evenly items-center bg-[#FFFFFF] flex-col lg:flex-row relative !px-10">
        <div className=" flex flex-col gap-y-5 items-start -mt-0  lg:-mt-20 xl:-mt-40 ml-0 md:ml-20">
          {/* content */}
          <div className="  flex flex-col gap-y-0 font-Uberhand font-extrabold mx-auto mt-0 lg:mt-40  2xl:mt-0 ">
            <div className=" flex gap-x-5 flex-col items-center lg:flex-row ">
              <p
                className="text-[50px] lg:text-[70px] drop-shadow-xl text-primary-color"
                style={{ textShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)" }}
              >
                {t('mainSlider', 'text1')}
              </p>
              <p
                className="text-[50px] lg:text-[70px]  text-yellow-color  drop-shadow-xl -mt-5 lg:mt-0 "
                style={{ textShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)" }}
              >
                {t('mainSlider', 'text2')}
              </p>
            </div>
            {/* <p
              className="text-[50px] lg:text-[60px] drop-shadow-xl flex justify-center lg:justify-start -mt-5"
              style={{ textShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)" }}
            >
            </p> */}
            <p
              className="text-[50px] lg:text-[70px] drop-shadow-xl flex justify-center  -mt-5 text-primary-color"
              style={{ textShadow: "4px 4px 10px rgba(0, 0, 0, 0.3)" }}
            >
              {t('mainSlider', 'text3')}
            </p>
          </div>

          {/* input */}
          <div className="w-full lg:w-3/5 mt-8 mb-8 ml-0 md:ml-10">
            <SearchInput type="categories" />
          </div>
        </div>

        {/* img */}
        <div className="my-8 mt-20 lg:mb-2 xl:mb-36 hidden lg:block max-w-[250px] aspect-[43/100]">
          <img
            loading="eager"
            src="https://ucarecdn.com/4a05e0a8-a303-4a6f-99ee-03509c1652bf/-/preview/430x1000/"
            alt="Orthopedic support product"
            className="w-full h-full object-cover rounded"
          />
        </div>

      </div>
      {/* <div className="absolute lg:-bottom-20 xl:w-8/12 2xl:w-6/12  mx-auto rounded-[25px] hidden xl:flex justify-center items-center px-8 py-4 shadow-lg shadow-gray-500 bg-white">
        <div className="flex justify-center items-center w-full">
          {data.map((item, i) => (
            <div key={i} className="flex items-center gap-x-5">
              <div className="flex flex-col items-center justify-center gap-y-5 px-5 w-full min-w-[150px] 2xl:min-w-[150px]">
                <div>
                  <img src={item?.img} alt="" className=" !w-[80px]"/>
                </div>
                <div>
                  <p className="text-[#777497] text-center text-xs 2xl:text-base">{item?.name}</p>
                </div>
              </div>
              {i !== data.length - 1 && (
                <div className="border-r-4 border-yellow-color h-[110px] rounded-xl"></div>
              )}
            </div>
          ))}
        </div>
      </div> */}
      {
        scrolled ?
          <Discount />
          :
          <></>
      }

    </div>
  );
};

export default MainSlider;
